function Splash() {
  return (
    <div className="bg-[#7A68FF] h-[812px] w-[375px] flex items-center justify-center">
      <div className="font-jakarta text-white text-[102.4px] font-semibold mb-40">
        QQ
      </div>
    </div>
  );
}

export default Splash;
